export function strToFile(value: string, name: string, type: string) {
  const bstr = window.atob(value);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], name, { type });
}
